module.exports = __webpack_public_path__ + "img/arrow_left_color.578cd866.svg";